import { axiosGet, axiosPost } from '../ServiceBase.js';

export const findAutorizacionesAmbulatorias = async (data = null) => {
  return axiosPost('/v1/autorizaciones/ambulatorias', data);
};

export const getAutorizacionAmbulatoria = async (id = 0) => {
  return axiosGet(`/v1/autorizaciones/ambulatorias/${id}`);
};
